/**
 * There will be one reducer file per page / common component
 */
import {
    GET_PRODUCTSTEMPLATESFILTER_SUCCESS,
    GET_PRODUCTSTEMPLATESFILTER_FAILURE,
    GET_PRODUCTSTEMPLATESFILTER,
    SET_PRODUCTSTEMPLATESFILTER,
    SET_PRODUCT_TEMPLATE_REFINE_DATA,
    SET_PRODCUCT_TEMPLATE_SUB_CATEGORY_LIST,
    SET_EXPANDED_FILTER_VIEW,
    SET_ROUTE_PATH_FOR_TEMPLATES_UNSAVED_CHANGES_POP_UP,
    SET_TEMPLATES_UNSAVED_CHANGES_POP_UP,
} from '../actions';

const initialState = {
    productTemplateRefinedFilters: {},
    productsTemplatesFilterError: '',
    productsTemplatesFilterLoading: false,
    productTemplatesSelectedFilter: {},
    templateSubCategoryList: [],
    expandedFilterView: {
        TypeView: true,
        AccountView: true,
        PhysiciansView: false,
        ProcedureView: false,
        CreatedBy: false,
    },
    routePathForTemplatesUnsavedChangesPopUp: {
        path: '',
        selectOption: '',
    },
    unsavedTemplatesChangesPopUp: false,
};

const TemplatesReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_PRODUCT_TEMPLATE_REFINE_DATA:
            return {
                ...state,
                productTemplateRefinedFilters: action.payload,
            };
        case SET_PRODUCTSTEMPLATESFILTER:
            return {
                ...state,
                productTemplatesSelectedFilter: action.payload,
            };
        case GET_PRODUCTSTEMPLATESFILTER:
            return {
                ...state,
                productsTemplatesFilterLoading: true,
            };
        case GET_PRODUCTSTEMPLATESFILTER_SUCCESS:
            return {
                ...state,
                productTemplateRefinedFilters:
                    action.productTemplateRefinedFilters,
                productsTemplatesFilterError: '',
                productsTemplatesFilterLoading: false,
            };
        case GET_PRODUCTSTEMPLATESFILTER_FAILURE:
            return {
                ...state,
                productTemplateRefinedFilters: [],
                productsTemplatesFilterError: action.templateError,
                productsTemplatesFilterLoading: false,
            };
        case SET_PRODCUCT_TEMPLATE_SUB_CATEGORY_LIST:
            return {
                ...state,
                templateSubCategoryList: action.payload,
            };
        case SET_EXPANDED_FILTER_VIEW:
            return {
                ...state,
                expandedFilterView: action.payload,
            };
        case SET_TEMPLATES_UNSAVED_CHANGES_POP_UP:
            return {
                ...state,
                unsavedTemplatesChangesPopUp: action.payload,
            };
        case SET_ROUTE_PATH_FOR_TEMPLATES_UNSAVED_CHANGES_POP_UP:
            return {
                ...state,
                routePathForTemplatesUnsavedChangesPopUp: action.payload,
            };
        default: {
            return { ...state };
        }
    }
};

export default TemplatesReducer;
